export const splitByWords = (text: string, limit = 10) => {
  if (!text) return '';
  const regex = new RegExp(`((?:\\b\\w+\\b\\s?){${limit}})`, 'g');
  return text.replace(regex, '$1\n');
};
